<div id="pause">

    <div class="spinner">
        <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
        <!-- <p style="margin-left: 20px;">Please wait...</p> -->
    </div>
    

</div>